module.exports = __webpack_public_path__ + "static/media/house.88979d03.csv";